import { serviceConfig } from '../../config';
import { axiosInstance } from '../../services/shared';
import { AxiosResponse } from 'axios';
import { ColabComment } from './types';

async function getComments(feedbackRowKey: string | undefined) {
  const url = `${serviceConfig.endpoints.legacy.root}/${serviceConfig.endpoints.legacy.colab}/comment`;

  try {
    const response: AxiosResponse<ColabComment[]> = await axiosInstance.get(url, {
      params: { rowKey: feedbackRowKey },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching comments:', error);
    throw error;
  }
}

async function postComment(partitionKey: string, rowKey: string, comment: string) {
  const url = `${serviceConfig.endpoints.legacy.root}/${serviceConfig.endpoints.legacy.colab}/comment`;
  const payload = {
    partitionKey,
    rowKey,
    comment: comment,
  };

  try {
    const response: AxiosResponse<ColabComment[]> = await axiosInstance.post(url, payload);
    return response.data;
  } catch (error) {
    console.error('Error submitting comment:', error);
    throw error;
  }
}

export { getComments, postComment };
